import React from "react";
import { Box, Paper, Typography, Button, CircularProgress } from "@mui/material";
import { styled } from "styled-components";
import PropTypes from "prop-types";
import { MdOutlineClose } from "react-icons/md";

export const ToggleWalletActions = styled.div`
	position: relative;
`;

export const WalletActionsModal = styled.div`
	background: white;
	position: absolute;
	right: 0;
	top: 25px;
	z-index: 20;
	border-radius: 6px;
	padding: 8px 14px;
	display: flex;
	flex-direction: column;
	font-size: 14px;
	width: 160px;

	button {
		border-bottom: 1px solid #eef2f3;

		&:last-of-type {
			border: none;
		}
	}
`;

export const WalletAction = styled.button`
	text-align: start;
	padding: 6px 0px;
	color: #001318;

	&:hover {
		color: #00525d;
		font-weight: 600;
	}
`;

export const WalletInputField = styled.input`
	border: 1px solid gray;
	border-radius: 6px;
	padding: 0.6rem 0.75rem;
	outline: none;
	color: black;
	font-size: 1.1rem;

	&:focus {
		border: 2px solid #00525d;
	}

	&::placeholder {
		font-size: 15px;
	}
`;

export const SingleBank = styled.p`
	color: #000000de;
	font-size: 13.5px;
	padding: 6px 10px;
`;

export const WalletContainer = ({ children }) => (
	<Paper sx={{ borderRadius: 3, padding: 2.5, width: "90%", maxWidth: "450px", marginX: "auto" }}>
		{children}
	</Paper>
);

export const WalletHeader = ({ headerText, onCloseModal, context, amount, color }) => (
	<>
		<Box display='flex' justifyContent='space-between' alignItems='start'>
			<Typography component='h2' variant='h6'>
				{headerText}
			</Typography>
			<button onClick={onCloseModal}>
				<MdOutlineClose size={20} color='#00525D' />
			</button>
		</Box>
		<Typography component='p' variant='body2' marginTop={0.5}>
			{context}
			<span style={{ fontWeight: 500, color }}>{amount}</span>
		</Typography>
	</>
);

export const WalletBtns = ({
	hideWhiteBtn,
	whiteBtnClick,
	greenBtnClick,
	isGreenBtnDisabled,
	btnText,
	isLoading,
}) => (
	<Box marginTop={4} display='flex' justifyContent='flex-end' gap='14px'>
		{!hideWhiteBtn && (
			<Button variant='outlined' sx={{ borderRadius: "6px" }} onClick={whiteBtnClick}>
				cancel
			</Button>
		)}
		<Button
			variant='contained'
			color='primary'
			sx={{ borderRadius: "6px" }}
			onClick={greenBtnClick}
			disabled={isGreenBtnDisabled || isLoading}>
			{isLoading ? (
				<CircularProgress color='primary' size={30} thickness={5} />
			) : btnText ? (
				btnText
			) : (
				"proceed"
			)}
		</Button>
	</Box>
);

export const ConfirmCard = ({ textOne, textTwo, textThree, textFour }) => {
	return (
		<Box display='flex' flexDirection='column' gap={1}>
			<div className='flex space-between gap-3' style={{ color: "#8E9DA4", fontSize: "13px", margin: 0 }}>
				<p>{textOne}</p>
				<p>{textTwo}</p>
			</div>
			<div className='flex space-between gap-3' style={{ color: "black", fontSize: "14px", margin: 0 }}>
				<p>{textThree}</p>
				<p>{textFour}</p>
			</div>
		</Box>
	);
};

export const ConfirmCardContainer = styled.div`
	display: grid;
	gap: 0.5rem;
	margin: 1rem 0;

	> div {
		border-bottom: 1px solid #e5e7eb;
		padding: 5px 0 7px;
	}
`;

export const PasswordWrapper = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.5rem;
	font-size: 14px;
	font-weight: 500;
	color: black;

	input {
		border: 1px solid gray;
		padding: 8px 12px;
		border-radius: 8px;

		&:focus {
			border: 2px solid #00525d;
		}
	}
`;

ConfirmCard.propTypes = {
	textOne: PropTypes.string,
	textTwo: PropTypes.string,
	textThree: PropTypes.string,
	textFour: PropTypes.string,
};

WalletContainer.propTypes = {
	children: PropTypes.element,
};

WalletHeader.propTypes = {
	headerText: PropTypes.string,
	onCloseModal: PropTypes.func,
	context: PropTypes.string,
	amount: PropTypes.string,
	color: PropTypes.string,
};

WalletBtns.propTypes = {
	greenBtnClick: PropTypes.func,
	whiteBtnClick: PropTypes.func,
	isGreenBtnDisabled: PropTypes.bool,
	btnText: PropTypes.string,
	isLoading: PropTypes.bool,
	hideWhiteBtn: PropTypes.bool,
};
